import { render, staticRenderFns } from "./InvoiceBill.vue?vue&type=template&id=2bf55854&scoped=true&"
import script from "./InvoiceBill.vue?vue&type=script&lang=js&"
export * from "./InvoiceBill.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceBill.vue?vue&type=style&index=0&id=2bf55854&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf55854",
  null
  
)

export default component.exports